import React, { createContext, useContext } from 'react';

const SubscriptionContext = createContext();
const HIDDEN_SUBSCRIPTION = {
  isSubscriber: false,
  discountPercentage: 0,
  expiryDate: null,
  checked: true,
  refetchSubscription: async () => {},
};

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
};

export const SubscriptionProvider = ({ children }) => {
  return (
    <SubscriptionContext.Provider value={HIDDEN_SUBSCRIPTION}>
      {children}
    </SubscriptionContext.Provider>
  );
};
